
        import 'BusinessDetails.6cbdef4.css-module'
        export default {"Contents":"Contents_BusinessDetails_6cbdef4","Details":"Details_BusinessDetails_6cbdef4"}
    